var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-black bg-center bg-no-repeat bg-cover rounded image-container",style:({ backgroundImage: _vm.url ? ("url(" + _vm.url + ")") : '' }),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }